import { useModelViewerGridAxesHelper } from './hooks/useModelViewerGridAxesHelper';

function ModelViewerGridAxesHelper() {
  useModelViewerGridAxesHelper();

  return null;
}

export default ModelViewerGridAxesHelper;
